import Service from "@ember/service"

export default class Dragging extends Service {
  isDragging = false
}
